import { useCallback, useRef } from 'react';
import { sameOrderTime } from '../util/listingOrderTime';

export default function useOrderTimeReconciliation(type) {
  const previousType = useRef(type);
  return useCallback(
    (current, nearest) => {
      const changedType = previousType.current !== type;
      previousType.current = type;
      // ASAP intent is stable, but its quoted window belongs to one mode.
      // If the new mode cannot resolve a window, discard the old estimate.
      if (!nearest) {
        return changedType && current?.type === 'asap'
          ? { type: 'asap', value: 'asap', label: 'ASAP' }
          : current;
      }
      return changedType || !sameOrderTime(current, nearest)
        ? nearest
        : current;
    },
    [type]
  );
}
